import { el, enGB } from "date-fns/locale";

import { format as fnFormat } from "date-fns";

export const format = (date, format, locale = "en") => {
  return fnFormat(date, format, { locale: locale === "en" ? enGB : el });
};
